import { useIsPeopleUnlockButtonLoading } from '@aibees/elephant/components/people-unlock/hooks/use-is-people-unlock-button-loading';
import { ProfileDetailsNoData } from '@aibees/elephant/components/profile-details-no-data';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { ContactDetailItemHeader } from '../../../contact-detail-item-header';
import { useContactDetailsState } from '../../context';
import { useSetSeemoreVisibility } from '../../hooks/use-set-seemore-visibility';
import * as EXTERNALSX from '../../sx';
import { doesContactDetailHaveUpdate } from '../../utils';
import { EducationItem } from './components/education-item';
import * as SX from './sx';
import type { EducationProps as Props } from './types';

export const Education = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const { api } = usePersonReadDataContext();
    const { loadingContactDetails } = useIsPeopleUnlockButtonLoading(api.data);
    const { unlocked, isPopoverType } = useContactDetailsState();
    useSetSeemoreVisibility(
      setShowSeeMore,
      itemsLimit,
      api.data?.educations?.length
    );
    const hasUpdate = doesContactDetailHaveUpdate(
      PersonContactDetailsItem.EDUCATIONS,
      api.data
    );

    const content = (
      <Stack direction="column" gap={1}>
        {hasUpdate && api.data?.educations?.[0] && (
          <div
            key={-1}
            style={{
              filter: 'blur(4px)',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <EducationItem
              key={-1}
              item={api.data?.educations?.[0]}
              index={-1}
            />
          </div>
        )}
        {api.data?.educations?.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          return (
            <EducationItem key={index} item={item} index={index} isSidebar />
          );
        })}
      </Stack>
    );

    return (
      <Box className={classnames('Education', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Education"
          count={api.data?.educations?.length ?? 0}
        />
        {!unlocked || loadingContactDetails ? (
          <ProfileDetailsNoData />
        ) : isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

Education.displayName = 'Education';
